import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';
import { TOPIC_KEYS } from './progress';
import { buildTimeline } from './timeline';

/** Length of the guide in the current language: { minutes, topics }. */
export const useGuideLength = () => {
  const { t } = useTranslation();
  return useMemo(() => ({
    minutes: Math.max(1, Math.round(buildTimeline(t).total / 60000)),
    topics: TOPIC_KEYS.length,
  }), [t]);
};

/**
 * Open / close state of the guide player. `open()` starts from the top,
 * `open({ chapter })` from a topic, `open({ beat })` from a step (to resume).
 */
const useUserGuide = () => {
  const [state, setState] = useState({ isOpen: false, start: null });
  const open = useCallback((start = null) => setState({ isOpen: true, start }), []);
  const close = useCallback(() => setState((current) => ({ ...current, isOpen: false })), []);
  return { ...state, open, close };
};

export default useUserGuide;
